<div class="encabezado">
  <div class="col-4 getBack">
    <a routerLink="/settings">
      <span><i class="icon-chevron-left"></i>{{ "forms.buttons.back" | translate }}</span>
    </a>
  </div>

  <h5 class="titulo1">{{ "settings.order_freeze.title" | translate }}</h5>

  <div *ngIf="isLoading" class="text-center py-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <div *ngIf="!isLoading && isSupplier" class="freeze-container">
    <p class="text-muted">{{ "settings.order_freeze.description" | translate }}</p>

    <div class="freeze-toggle-row">
      <div class="freeze-status">
        <span class="badge" [ngClass]="autoFreezeEnabled ? 'bg-success' : 'bg-secondary'">
          {{ (autoFreezeEnabled ? "settings.order_freeze.enabled" : "settings.order_freeze.disabled") | translate }}
        </span>
      </div>
      <button type="button" class="btn btn-sm"
        [ngClass]="autoFreezeEnabled ? 'btn-outline-danger' : 'btn-primary'"
        (click)="toggleFreeze()">
        {{ (autoFreezeEnabled ? "settings.order_freeze.btn_disable" : "settings.order_freeze.btn_enable") | translate }}
      </button>
    </div>

    <div class="freeze-info mt-3">
      <p class="small text-muted" *ngIf="autoFreezeEnabled">
        <i class="icon-info"></i> {{ "settings.order_freeze.info_enabled" | translate }}
      </p>
      <p class="small text-muted" *ngIf="!autoFreezeEnabled">
        <i class="icon-info"></i> {{ "settings.order_freeze.info_disabled" | translate }}
      </p>
    </div>
  </div>

  <div *ngIf="!isLoading && !isSupplier" class="text-center py-5">
    <p class="text-muted">{{ "settings.order_freeze.supplier_only" | translate }}</p>
  </div>
</div>
